import { render, staticRenderFns } from "./CookiesSnackbar.vue?vue&type=template&id=0ba77378"
import script from "./CookiesSnackbar.vue?vue&type=script&lang=js"
export * from "./CookiesSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CookiesSnackbar.vue?vue&type=style&index=0&id=0ba77378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports